import { render, staticRenderFns } from "./zbindex.vue?vue&type=template&id=f827c78e&scoped=true"
import script from "./zbindex.vue?vue&type=script&lang=js"
export * from "./zbindex.vue?vue&type=script&lang=js"
import style0 from "./zbindex.vue?vue&type=style&index=0&id=f827c78e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f827c78e",
  null
  
)

export default component.exports